import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../../Component/Card Viola/cardviola.jsx";
import BumiLuhurimages from "../../../media/kbp/Bumi Luhur/Bumi Luhur.js";
import Nilapadmiimages from "../../../media/kbp/Nilapadmi/Nilapadmi.js";
import Paramawatiimages from "../../../media/kbp/Paramawati/Paramawati.js";
import Simaimages from "../../../media/kbp/Sima.js";
import Tarubhawanaimages from "../../../media/kbp/Tarubhawana/Tarubhawana.js";
import Prakarsaimages from "../../../media/kbp/Jaya Prakarsa/JayaPrakarsa.js";
import Kartawijayaimages from "../../../media/kbp/Tatar Kartawijaya/Kartawijaya.js";
import kblimages from "../../../media/kbp/Kartawijaya Bussiness Loft/KBL.js";
import Bungawariimages from "../../../media/kbp/Bungawari/Bungawari.js";

const imageMap = {
  BumiLuhurimages,
  Nilapadmiimages,
  Paramawatiimages,
  Simaimages,
  Tarubhawanaimages,
  Prakarsaimages,
  Kartawijayaimages,
  kblimages,
  Bungawariimages,
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
